import { useState } from "react";
import { useDispatch } from "react-redux";
import { trackEvent } from "../../analytics/store/analyticsSlice";

interface UseFormattedCopyOptions {
  elementId: string;
}

export const useFormattedCopy = ({ elementId }: UseFormattedCopyOptions) => {
  const dispatch = useDispatch();
  const [copySnackbarOpen, setCopySnackbarOpen] = useState(false);

  const handleCopy = async () => {
    const el = document.getElementById(elementId);
    if (!el) return;

    try {
      // Clone the element to avoid modifying the displayed content
      const clone = el.cloneNode(true) as HTMLElement;
      // Remove insight tooltips from the clone
      const insightElements = clone.querySelectorAll(".insight-reference");
      insightElements.forEach((el) => el.remove());
      // Get clean HTML without insight markers
      const html = clone.innerHTML;

      const blob = new Blob([html], { type: "text/html" });
      const textBlob = new Blob([clone.textContent || clone.innerText || ""], {
        type: "text/plain",
      });
      const data = [
        new ClipboardItem({
          "text/html": blob,
          "text/plain": textBlob,
        }),
      ];

      await navigator.clipboard.write(data);
      dispatch(trackEvent({ name: "agent_message_copied" }));
      setCopySnackbarOpen(true);
    } catch (error) {
      console.error("Failed to copy text:", error);
    }
  };

  const handleSnackbarClose = () => {
    setCopySnackbarOpen(false);
  };

  return {
    handleCopy,
    copySnackbarOpen,
    handleSnackbarClose,
  };
};
